import { useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { Section } from 'foundations-components/transitional/components/Section';
import ToolRecommendationsForLearningContent from './ToolRecommendationsForLearningContent';
import { useGetToolRecommendations } from '../queries/softwareDiscoveryHooks';
import { BaseContentControlWrapper } from '../../../components/ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OptionalToolRecommendationSection = ({
  contentName,
  lessonId,
  nextLessonId,
  trackId,
  useCases = []
}) => {
  const {
    push,
    location
  } = useHistory();
  const toolRecommendations = useGetToolRecommendations(useCases);
  const {
    titleKey = '',
    descriptionKey = ''
  } = toolRecommendations || {};
  const onClickingNext = () => push(Object.assign({}, location, {
    pathname: `/tracks/${trackId}/${nextLessonId}`
  }));
  const onClickingSkip = () => push(Object.assign({}, location, {
    pathname: `/lessons/${lessonId}/recommendations`
  }));
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-accent-neutral-default",
    "data-test-id": "optional-tool-recommendation-section",
    children: [/*#__PURE__*/_jsx(View, {
      position: "relative",
      children: /*#__PURE__*/_jsx(Ribbon, {
        marginBlockStart: "300",
        position: "left",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.optionalSideNav.optionalStep"
        })
      })
    }), /*#__PURE__*/_jsx(ToolRecommendationsForLearningContent, {
      cardWidth: 242,
      contentName: contentName,
      renderRecommendations: commonContent => {
        return /*#__PURE__*/_jsxs(Section, {
          padding: "1000",
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h1",
              color: "text-alert-on-fill-default",
              textAlign: "center",
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: titleKey
              })
            }), /*#__PURE__*/_jsx(Text, {
              color: "text-alert-on-fill-default",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: descriptionKey
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            as: "div",
            marginBlock: "1000",
            children: commonContent
          })]
        });
      },
      toolsToDisplay: 3,
      useCases: useCases
    }), /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: trackId ? /*#__PURE__*/_jsx(Button, {
        onClick: onClickingNext,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.next"
        })
      }) : /*#__PURE__*/_jsx(Button, {
        onClick: onClickingSkip,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.linkContent.skip"
        })
      })
    })]
  });
};
export default OptionalToolRecommendationSection;